import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { GetMyCertificateService } from '../../services/ProfileService';
import { download } from '../../utils/FileDownload';
import ResultWithHeldCard from '../common/ResultWithHeldCard';
import SkeletonContainer, { getSkeletonHeight } from '../../loaders/SekletonContainer';
import Str from '../common/Str';
import { StandardButton } from '../common/GlobalElements/StandardButton';
import { LabelMedium, TextLink } from '../common/GlobalElements/Typography';
import { ContainerWrapper } from '../common/GlobalElements/Wrappers';
import { normalizeActionColumns } from '../../utils/tableColumns';
const Certificates = () => {
    const [search, setSearch] = useState('');
    const [certificates, setCertificate] = useState([]);
    const [renderTable, setRenderTable] = useState(true);
    const isWithHeldStatus = localStorage.getItem('resultWithHeld');

    useEffect(() => {
        setRenderTable(false);
        GetMyCertificateService()
            .then((res) => {
                const respData = res.data.certificates;
                setCertificate(respData);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setRenderTable(true);
            });
    }, []);

    const columns = [
        {
            name: 'Certificate Name',
            selector: 'certificate_name',
            sortable: true,
            wrap: true,
            cell: (row) => (
                <div class="assessment-01">
                    <p class="as-text-blue">
                        <span className="overflow-ellipsis2">
                            <TextLink href={row.certificate} target="_blank" title={row.certificate_name}>
                                {row.certificate_name}
                            </TextLink>
                        </span>
                    </p>
                </div>
            ),
        },
        {
            name: 'Your Certificate',
            selector: 'certificate_original_name',
            sortable: true,
            wrap: true,
        },
        {
            name: 'Action',
            width: '74px',
            sortable: false,
            cell: (row) => (
                <div className="assessment-08 advSearch-action-con">
                    <div className="as-buttons">
                        <StandardButton
                            as="a"
                            href={row.certificate}
                            target="_blank"
                            variant="primary"
                            isRounded={true}
                            title="View"
                        >
                            <i className="fal fa-eye"></i>
                        </StandardButton>
                    </div>
                    <div className="as-buttons">
                        <StandardButton
                            variant="primary"
                            isRounded={true}
                            title="Download"
                            onClick={() => download(row.certificate, row.certificate_original_name, row.id)}
                        >
                            <i className="fal fa-download"></i>
                        </StandardButton>
                    </div>
                </div>
            ),
        },
    ];

    const resetFilter = () => {
        setSearch('');
    };

    const handleSearchFilter = (e) => {
        setSearch(e.target.value);
    };

    const dataToRender = () => {
        let updatedData = [];
        let data = [...certificates];

        if (search.length) {
            let tempName = data.filter((item) => {
                let includes = item?.certificate_name.toLowerCase().includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else {
                    return null;
                }
            });
            let tempOriginName = data.filter((item) => {
                let includes = item?.certificate_original_name.toLowerCase().includes(search.toLowerCase());
                if (includes) {
                    return includes;
                } else {
                    return null;
                }
            });

            const finalData = [...tempName, ...tempOriginName];

            let unique = [...new Set(finalData)];

            updatedData = unique;
        } else {
            updatedData = data;
        }

        return updatedData;
    };

    return (
        <>
            {isWithHeldStatus == 'true' ? (
                <ResultWithHeldCard />
            ) : (
                <ContainerWrapper
                    variant="outline"
                    className="custom-table-div filter-search-icon card card-table-custom"
                >
                    <div className="search-filter-div">
                        <div className="search-filter-div-left">
                            <div className="system-administration-table table-responsive">
                                <div className="table-responsive-div">
                                    <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                                        <div id="assessment-table-main_filter" className="dataTables_filter">
                                            <LabelMedium for="filterDataTable" className="icon"></LabelMedium>
                                            <input
                                                type="text"
                                                name="filterDataTable"
                                                className="filter-text"
                                                placeholder="Search"
                                                onChange={handleSearchFilter}
                                                value={search}
                                            />
                                            <div className="filter-eff filter-data-btn">
                                                <span className="filter-buttons">
                                                    <i className="fal fa-filter"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="filter-button-group">
                                    <div className="reset-btn-group">
                                        <div className="button-reset">
                                            <StandardButton onClick={resetFilter} title="Reset">
                                                <i className="fal fa-redo"></i>Reset
                                            </StandardButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DataTable
                        columns={normalizeActionColumns(columns)}
                        data={dataToRender()}
                        progressPending={!renderTable}
                        pagination={true}
                        defaultSortField="certificate_name"
                        defaultSortAsc={false}
                        highlightOnHover={false}
                        progressComponent={<SkeletonContainer height={getSkeletonHeight(10)} />}
                        noDataComponent={Str.noRecord}
                    />
                </ContainerWrapper>
            )}
        </>
    );
};

export default Certificates;
